import EventDispatcher from "@/events/EventDispatcher";
import AppEvent from "@/events/AppEvent";

export default class ImagePreloader extends EventDispatcher {
  
  constructor() {
    super();
  }
  
  /**
   * 画像一式をロードする
   * @param imagesList 読み込む画像のURLリスト
   */
  load = async (imagesList: string[]): Promise<any> => {
    const amount = imagesList.length;
    if (amount > 0) {
      try {
        const images: any[] = [];
        for (let i = 0; i < amount; i++) {
          const image = await this.loadImage(imagesList[i]);
          images.push(image);
        }
        return Promise.resolve(images);
      }
      catch (error) {
        return Promise.reject(error);
      }
    }
    else {
      const noImageError = new Error('Image List is Empty');
      return Promise.reject(noImageError);
    }
  };
  
  /**
   * 画像を読み込んで返す非同期メソッド
   * @param imageUrl
   */
  protected loadImage = async (imageUrl: string): Promise<any> => {
    return new Promise ((resolve, reject) => {
      const image: HTMLImageElement = new Image();
      image.onload = (): void => {
        console.log('onLoad: ' + imageUrl);
        image.onload = null;
        image.onerror = null;
        resolve(image);
      };
      image.onerror = (error): void => {
        console.log('onError: ', error);
        image.onload = null;
        image.onerror = null;
        reject(error);
      };
      image.src = imageUrl;
    });
  }
}
